'use client';

import { c as _c } from "react/compiler-runtime";
import type { Hash } from 'viem';
import { Button, type ButtonProps, cn } from '@repo/ui';
import { isValidElement, type ReactNode } from 'react';
import type { ChainId } from '../../../web3.types';
import { ActionFlowTransactionSummary } from './ActionFlowTransactionSummary';
interface ActionFlowSuccessButtonProps {
  hash?: Hash | null;
  chainId: ChainId;
  className?: string;
  label?: string | ReactNode;
  buttonProps?: ButtonProps;
}
export function ActionFlowSuccessButton(t0) {
  const $ = _c(15);
  const {
    hash,
    chainId,
    className,
    label: t1,
    buttonProps
  } = t0;
  const label = t1 === undefined ? "Done" : t1;
  let t2;
  if ($[0] !== className) {
    t2 = cn("w-full space-y-2", className);
    $[0] = className;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== buttonProps?.asChild || $[3] !== label) {
    t3 = buttonProps?.asChild && isValidElement(label) ? label : <div>{label}</div>;
    $[2] = buttonProps?.asChild;
    $[3] = label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== buttonProps || $[6] !== t3) {
    t4 = <Button size="lg" fullWidth={true} variant="success" data-testid="transaction-success-button" {...buttonProps}>{t3}</Button>;
    $[5] = buttonProps;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== chainId || $[9] !== hash) {
    t5 = hash && <ActionFlowTransactionSummary hash={hash} chainId={chainId} status="success" />;
    $[8] = chainId;
    $[9] = hash;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t4 || $[13] !== t5) {
    t6 = <div className={t2}>{t4}{t5}</div>;
    $[11] = t2;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  return t6;
}